export function dateFormat(value) {
    return value ? value.replace("T", " ") : ""
}